import {
  FETCH_USER_TYPE_FAILED,
  FETCH_USER_TYPE_SUCCESS,
  FETCH_USER_TYPE,
  FETCH_LANGUAGES,
  FETCH_LANGUAGES_FAILED,
  FETCH_LANGUAGES_SUCCESS,
  FETCH_TEAMS,
  FETCH_TEAMS_FAILED,
  FETCH_TEAMS_SUCCESS,
  FETCH_PRODUCTS,
  FETCH_PRODUCTS_FAILED,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_USER_LIST,
  FETCH_USER_LIST_SUCCESS,
  FETCH_USER_LIST_FAILED,
  INSERT_NEW_USER,
  INSERT_NEW_USER_SUCCESS,
  INSERT_NEW_USER_FAILED,
  UPDATE_USER_DETAILS,
  UPDATE_USER_DETAILS_SUCCESS,
  UPDATE_USER_DETAILS_FAILED,
  FILE_UPLOAD,
  FILE_UPLOAD_SUCCESS,
  FILE_UPLOAD_FAILED,
  API_URL,
  UPDATE_EXISTING_KEYWORD,
  UPDATE_EXISTING_KEYWORD_SUCCESS,
  UPDATE_EXISTING_KEYWORD_FAILED,
} from "../constants/constants";
import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import cookie from "react-cookies";

function* fetchUserList() {
  const user_id = cookie.load("username");
  const data = { user_id: user_id };
  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/get-user`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    );
    yield put({ type: FETCH_USER_LIST_SUCCESS, data: result.data });
  } catch (error) {
    yield put({ type: FETCH_USER_LIST_FAILED, data: error });
  }
}

function* fetchUserLanguages() {
  try {
    const result = yield call(() => axios.get(`${API_URL}/get-language`));
    yield put({ type: FETCH_LANGUAGES_SUCCESS, data: result.data });
  } catch (error) {
    yield put({ type: FETCH_LANGUAGES_FAILED, data: error });
  }
}

function* fetchProducts() {
  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/get-product-list`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    );
    yield put({ type: FETCH_PRODUCTS_SUCCESS, data: result.data });
  } catch (error) {
    yield put({ type: FETCH_PRODUCTS_FAILED, data: error });
  }
}

function* fetchTeams() {
  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/get-team-list`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    );
    yield put({ type: FETCH_TEAMS_SUCCESS, data: result.data });
  } catch (error) {
    yield put({ type: FETCH_TEAMS_FAILED, data: error });
  }
}

function* fetchUserTypes() {
  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/user-type-details`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    );
    yield put({ type: FETCH_USER_TYPE_SUCCESS, data: result.data });
  } catch (error) {
    yield put({ type: FETCH_USER_TYPE_FAILED, data: error });
  }
}

function* insertNewUser(action) {
  const {
    LoginId,
    Password,
    BaseLanguage,
    OtherLanguages,
    UserPrivilege,
    Createdby,
    EmployeeName,
    ProductIds,
    TeamId,
  } = action.payload;
  const toPost = {
    LoginId,
    Password,
    BaseLanguage,
    OtherLanguages,
    UserPrivilege,
    Createdby,
    EmployeeName,
    ProductIds,
    TeamId,
  };
  try {
    let result = yield call(() =>
      axios.post(`${API_URL}/add-product-and-team`, toPost, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    );
    if (result.data[0].Status === 0)
      yield put({ type: INSERT_NEW_USER_SUCCESS, data: result });
    else yield put({ type: INSERT_NEW_USER_FAILED, data: result.data[0] });
  } catch (error) {
    yield put({ type: INSERT_NEW_USER_FAILED, data: error });
  }
}

function* updateUserDetails(action) {
  const { toBeUpdated, ut, up, TeamId, modifiedBy } = action.payload;
  const toPost = {
    LoginId: toBeUpdated.login_id,
    Password: toBeUpdated.password || "",
    Status: toBeUpdated.status.toString(),
    BaseLanguage: toBeUpdated.language,
    OtherLanguages: toBeUpdated.OtherLanguages,
    UserPrivilege: ut.toString(),
    ProductIds: up.toString(),
    TeamId: Number(TeamId.toString()),
    Createdby: modifiedBy,
    EmployeeName: toBeUpdated.EmployeeName,
  };
  try {
    let result = yield call(() =>
      axios.post(`${API_URL}/update-product-and-team`, toPost, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    );
    yield put({ type: UPDATE_USER_DETAILS_SUCCESS, data: result });
  } catch (error) {
    yield put({ type: UPDATE_USER_DETAILS_FAILED, data: error });
  }
}
function* requestToFileUpload(action) {
  let bodyFormData = new FormData();
  bodyFormData.set("file", action.payload);
  try {
    let result = yield call(() =>
      axios.post(`${API_URL}/keywords_checking`, bodyFormData, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    );
    yield put({ type: FILE_UPLOAD_SUCCESS, data: result });
  } catch (error) {
    yield put({ type: FILE_UPLOAD_FAILED, data: error });
  }
}

function* updateExistingKeywords(action) {
  const { keywords, flag } = action.payload;
  const toPost = {
    selectedKeywords: keywords,
    flag: flag.toString(),
  };
  try {
    let result = yield call(() =>
      axios.post(`${API_URL}/keywords_existed`, toPost, {
        headers: {
          "Content-Type": "application/json",
        },
      })
    );
    yield put({ type: UPDATE_EXISTING_KEYWORD_SUCCESS, data: result });
  } catch (error) {
    yield put({ type: UPDATE_EXISTING_KEYWORD_FAILED, data: error });
  }
}

function* SuperAdminManagement() {
  yield takeLatest(FETCH_USER_LIST, fetchUserList);
  yield takeLatest(FETCH_LANGUAGES, fetchUserLanguages);
  yield takeLatest(FETCH_PRODUCTS, fetchProducts);
  yield takeLatest(FETCH_TEAMS, fetchTeams);
  yield takeLatest(FETCH_USER_TYPE, fetchUserTypes);
  yield takeLatest(INSERT_NEW_USER, insertNewUser);
  yield takeLatest(UPDATE_USER_DETAILS, updateUserDetails);
  yield takeLatest(FILE_UPLOAD, requestToFileUpload);
  yield takeLatest(UPDATE_EXISTING_KEYWORD, updateExistingKeywords);
}

export default SuperAdminManagement;
